import React from "react";
import { SelectableChatBoxListStateContext } from "../SelectableChatBoxListContext";

export const useSelectableChatBoxListState = () => {
	return React.useContext(SelectableChatBoxListStateContext);
};
